import { atom } from "jotai";

export const tutoFirstCreateCenterAtom = atom<boolean>(true); // Initial value is false
export const tutoFirstCreateProfilAtom = atom<boolean>(true); // Initial value is false
